import React, {useState, useEffect, useContext} from 'react';
import {Platform} from 'react-native';
import {isEmpty, validPassword} from '../../utils/HelperMethods';
import {fetchApi} from '../../utils/ApiHelper';
import {
  CHANGE_PASSWORD,
  HTTP_METHODS,
  loginAndSaveDetailsGlobal,
} from '../../utils/URLConstants';
import {loadingPauseContext} from '../../contexts/LoadingPauseContext';
import {errorStatusContext} from '../../contexts/ErrorStatusContext';
import UI from './ui';
import * as Keychain from 'react-native-keychain';
import {storeData, storeUserProfileData} from '../../utils/GeneralStorage';
import {KEYS, USER_AUTH_STATUS} from '../../utils/Constants';

const ChangeTemporaryPassword = ({
  navigation,
  authCredentials,
  setAuthCredentials,
  moveToNextStep = () => {},
  ...props
}) => {
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showRepeatPassword, setShowRepeatPassword] = useState(false);
  const [isValidForm, setValidForm] = useState(false);
  const [hasPasswordError, setHasPasswordError] = useState(false);
  const [hasRepeatPasswordError, setHasRepeatPasswordError] = useState(false);

  const lpc = useContext(loadingPauseContext);
  const esc = useContext(errorStatusContext);

  useEffect(() => {
    validatePasswordRecovery();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- validation intentionally keyed to password fields only
  }, [password, repeatPassword]);

  const onPressShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const onPressShowRepeatPassword = () => {
    setShowRepeatPassword(!showRepeatPassword);
  };

  const redirectToDiabetesType = () => {
    if (Platform.OS === 'web') {
      moveToNextStep(5);
    } else {
      navigation.navigate('DiabetesType');
    }
  };

  const validatePasswordRecovery = () => {
    if (isEmpty(password) || isEmpty(repeatPassword)) {
      setValidForm(false);
      return;
    }

    setValidForm(true);
  };

  const onPressSave = () => {
    if (!validPassword(password)) {
      setHasPasswordError(true);
      return;
    } else {
      setHasPasswordError(false);
    }

    if (password !== repeatPassword) {
      setHasRepeatPasswordError(true);
      return;
    } else {
      setHasRepeatPasswordError(false);
    }

    const postData = {
      password: password,
      repeatPassword: repeatPassword,
    };
    lpc.setVisible(true);
    fetchApi(HTTP_METHODS.POST, CHANGE_PASSWORD, postData)
      .then(response => {
        if (response.status == 200) {
          loginAndSaveDetails(password);
        } else {
          lpc.setVisible(false);
        }
      })
      .catch(error => {
        lpc.setVisible(false);
        esc.showError(error);
      });
  };

  const loginAndSaveDetails = async newPassword => {
    //storing new passowrd in local in web and keychian in mobile
    if (Platform.OS === 'web') {
      setAuthCredentials({...authCredentials, password: newPassword});
    } else {
      const credentials = await Keychain.getGenericPassword();
      await Keychain.setGenericPassword(credentials.username, password);
    }

    loginAndSaveDetailsGlobal(authCredentials?.username, newPassword)
      .then(async res => {
        lpc.setVisible(false);
        if (res.status === 200) {
          //store the received user token
          // DLog(res.data.data);
          if (Platform.OS === 'web') {
            //API has updated the variable name for token
            await storeData(KEYS.userToken, res.data.data.accessToken);
          } else {
            await storeData(KEYS.userToken, res.data.data.token);
          }
          await storeData(KEYS.isLogin, USER_AUTH_STATUS.login);
          await storeData(KEYS.userId, res.data.data.id);
          await storeUserProfileData(res.data.data);

          setTimeout(() => {
            redirectToDiabetesType();
          }, 1000);
        }
      })
      .catch(e => {
        lpc.setVisible(false);
        esc.showError(e);
      });
  };

  const uiProps = {
    navigation,
    password,
    showPassword,
    repeatPassword,
    showRepeatPassword,
    isValidForm,
    hasPasswordError,
    hasRepeatPasswordError,
    setPassword,
    setRepeatPassword,
    onPressSave,
    onPressSkip: redirectToDiabetesType,
    onPressShowPassword,
    onPressShowRepeatPassword,
    ...props,
  };

  return <UI {...uiProps} />;
};

export default ChangeTemporaryPassword;
